<template>
  <div id="app">
    <Welcome v-if="!gameStart && !showScore" @start-game="start"/>
    <div class="game" v-if="gameStart" @click.left="shot" @click.right="fillup">
      <Time :time="time"/>
      <Score :score="score"/>
      <FlyingDuck v-for="duck in ducks" :direction="duck.direction"
                  :position-top="duck.positionTop" :show="duck.show" :munitions="munitions"
                  :key="duck.id" :duck-key="duck.id" @flying-duck-animation-end="hideFlyingDuck"
                  @flying-duck-hit="countScore"/>
      <FillUp @fillup="fillup"/>
      <Munitions :munitions="munitions"/>
      <Sound sound-name="shotSound" sound-file="sound/shot.mp3"/>
      <Sound sound-name="reloadAmmunitionSound" sound-file="sound/reload-ammunition.mp3"/>
    </div>
    <ScoreTable v-if="showScore" :score="score" @start-game="start"/>
  </div>
</template>

<script>
import FillUp from './components/FillUp'
import FlyingDuck from './components/FlyingDuck'
import Munitions from './components/Munitions'
import Score from './components/Score'
import ScoreTable from './components/ScoreTable'
import Sound from './components/Sound'
import Time from './components/Time'
import Welcome from './components/Welcome'

export default {
  name: 'App',
  props: {
    config: Object,
    initialMunitions: Number,
    initialTime: Number
  },
  data: function () {
    return {
      ducks: [],
      gameStart: false,
      munitions: this.initialMunitions,
      refreshDuckTime: null,
      score: 0,
      showScore: false,
      time: this.initialTime,
      timer: null
    }
  },
  components: {
    FillUp,
    FlyingDuck,
    Munitions,
    Score,
    ScoreTable,
    Sound,
    Time,
    Welcome
  },
  methods: {
    addDuck: function () {
      var randomDirection = this.randomNumber(0, this.config.direction.length - 1);
      var randomPositionTop = this.randomNumber(0, this.config.positionTop.length - 1);

      this.ducks.push({
        id: this.ducks.length + 1,
        direction: this.config.direction[randomDirection],
        positionTop: this.config.positionTop[randomPositionTop],
        show: true
      });
    },
    fillup: function (plusOne) {
      if (this.munitions < this.initialMunitions) {
        this.playSound('reloadAmmunitionSound');
        if (plusOne === true) {
          this.munitions = this.initialMunitions + 1;
        } else {
          this.munitions = this.initialMunitions;
        }
      }
    },
    shot: function () {
      if (this.munitions > 0) {
        this.playSound('shotSound');
        this.munitions--;
      }
    },
    countScore: function (positionTop) {
      switch (positionTop) {
        case 'high':
          this.score += 25;
          break;
        case 'middle':
          this.score += 10;
          break;
        default:
          this.score += 5;
      }
    },
    hideFlyingDuck: function (key) {
      this.ducks[key - 1].show = false;
    },
    start: function () {
      this.changeState('start');

      this.timer = setInterval(function () {
        if (this.time === 0) {
          this.stop();
        } else {
          this.time--;
        }
      }.bind(this), 1000);

      this.refreshDuckTime = setInterval(function () {
        this.addDuck();
      }.bind(this), 2500);
    },
    stop: function () {
      this.changeState('stop');
      clearInterval(this.timer);
      clearInterval(this.refreshDuckTime);
    },
    changeState: function (state) {
      this.gameStart = false;
      this.showScore = false;

      switch (state) {
        case 'start':
          this.gameStart = true;
          break;
        case 'stop':
          this.showScore = true;
          break;
        default:
      }
    },
    playSound: function (soundElementId) {
      var soundElement = document.getElementById(soundElementId);
      soundElement.currentTime = 0;
      soundElement.play();
    },
    randomNumber: function (min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    }
  }
}
</script>

<style src="./scss/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue